import { render, staticRenderFns } from "./AddItemDialog.vue?vue&type=template&id=14e188b6&scoped=true&"
import script from "./AddItemDialog.vue?vue&type=script&lang=js&"
export * from "./AddItemDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14e188b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/driehle1/rezeptdatenbank/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14e188b6')) {
      api.createRecord('14e188b6', component.options)
    } else {
      api.reload('14e188b6', component.options)
    }
    module.hot.accept("./AddItemDialog.vue?vue&type=template&id=14e188b6&scoped=true&", function () {
      api.rerender('14e188b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/trip-shopping-list/AddItemDialog.vue"
export default component.exports